const runAsync = async function (loadingAction) {
  var _result, _result2;
  let withStatus = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  let result;
  let error;
  try {
    result = await loadingAction();
  } catch (err) {
    error = err;
  }
  return {
    data: withStatus ? (_result = result) === null || _result === void 0 ? void 0 : _result.data : result,
    ...(withStatus && {
      status: (_result2 = result) === null || _result2 === void 0 ? void 0 : _result2.status
    }),
    error
  };
};
export default runAsync;